import React, { useState } from 'react';
import { Breadcrumb, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { WorkerTable } from "../../components/Tables";
import { WorkerFilter } from '../../components/Filters';
// import { WorkerFilter } from "../../components/Filters";



export default () => {
    const [filter, setFilter] = useState({});
    const [refreshState, setRefreshState] = useState();


    return (
        <div className="justify-content-between flex-wrap flex-md-nowrap py-4">
            <div className="mb-4 mb-lg-0">
                <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
                    <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                    <Breadcrumb.Item>Recursos Humanos</Breadcrumb.Item>
                    <Breadcrumb.Item active>Funcionários</Breadcrumb.Item>
                </Breadcrumb>

                <Row className="d-flex flex-wrap flex-md-nowrap align-items-center py-4">
                    <Col className="d-block mb-4 mb-md-0">
                        <h1 className="h2">Funcionários</h1>
                        <p className="mb-0">
                            Tabela contendo todos os funcionários cadastrados.
                        </p>
                    </Col>
                </Row>
                <WorkerFilter setFilter={setFilter} refreshState={refreshState} setRefreshState={setRefreshState}/>
                <WorkerTable filter={filter} refreshState={refreshState} setRefreshState={setRefreshState}/> 
            </div>
        </div >
    );
};
